import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import LoadingScreen from './components/ui/LoadingScreen';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Telecommunication from './pages/divisions/Telecommunication';
import PowerDivision from './pages/divisions/Power';
import Hazardous from './pages/divisions/Hazardous';
import Commercial from './pages/divisions/Commercial';
import Industries from './pages/Industries';
import Companies from './pages/Companies';
import HazardousDivisionCompany from './pages/hazardousdivisioncompany';
import PowerDivisionCompany from './pages/powerdivisioncompany';
import TelecommunicationDivisionCompany from './pages/telecommunicationdivcompany';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';


function App() {
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence>
        {isLoading && <LoadingScreen isLoading={isLoading} />}
      </AnimatePresence>
      
      <Router>
        <ScrollToTop />
        <div className="App min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/divisions/telecommunication" element={<Telecommunication />} />
              <Route path="/divisions/power" element={<PowerDivision />} />
              <Route path="/divisions/hazardous" element={<Hazardous />} />
              <Route path="/divisions/commercial" element={<Commercial />} />
              <Route path="/clients-industries" element={<Industries />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/hazardousdivisioncompany" element={<HazardousDivisionCompany />} />
              <Route path="/powerdivisioncompany" element={<PowerDivisionCompany />} />
              <Route path="/telecommunicationdivcompany" element={<TelecommunicationDivisionCompany />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetails />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;